import { useIntl } from 'react-intl';

import { Typography } from '@/components/ui/typography';

interface NonIntegratedChannelsTableHeaderProps {
  gridTemplateColumns: string;
}

export function NonIntegratedChannelsTableHeader({
  gridTemplateColumns,
}: NonIntegratedChannelsTableHeaderProps) {
  const intl = useIntl();

  const tableHeaders = [
    intl.formatMessage({
      defaultMessage: 'Channel',
      description: 'Header for the channel name',
    }),
    intl.formatMessage({
      defaultMessage: 'Applicants attributed',
      description: 'Header for the applicant count',
    }),
    intl.formatMessage({
      defaultMessage: 'UTM sources',
      description: 'Header for the UTM sources',
    }),
    intl.formatMessage({
      defaultMessage: 'Actions',
      description: 'Header for the actions',
    }),
  ];

  return (
    <div
      className="border-fx-neutral-200 bg-fx-neutral-50 grid gap-x-4 border-y px-4 py-3.5"
      style={{ gridTemplateColumns }}
    >
      {tableHeaders.map(header => (
        <Typography
          variant="subtitle1"
          className="!text-fx-neutral-600"
          key={header}
        >
          {header}
        </Typography>
      ))}
    </div>
  );
}
